import { createApp } from 'vue'
import { createPinia } from 'pinia';
import router from './router';
import './style.css'
import App from './App.vue'
import {bootLogger} from "shared/boot/bootLogger";
import {bootErrorhandler} from "@codeages-private/qingjs-vue-skeleton-base";

const app = createApp(App);
// const logger = bootLogger();
bootErrorhandler(app);

const pinia = createPinia();
app.use(pinia);
app.use(router);

app.mount('#app');
